export const TOOLTIP_TEXT = "Your profile is still being reviewed by our team, but you can already submit your job application.";
export const APPLICATION_PROCESS_STEPS = [
    { _id: 1, text: 'Interview Request'},
    { _id: 2, text: 'Schedule Time'},
    { _id: 3, text: 'Conduct Interview'},
    { _id: 4, text: 'Client Response'},
];
